import { useCallback } from "react";

import * as Styled from "../../CreateWebService.styled";
import { Modal } from "react-bootstrap";

import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import Collapse from "react-bootstrap/Collapse";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AddNewWebServiceJson from "components/Leads/AddNewWebServiceJson";
import AddNewFields from "components/Leads/AddNewFields";
import { useSelector } from "react-redux";
import {
    Autocomplete,
    Box,
    Button,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import Json from "./Json";
const Content = ({
    error,
    authServices,
    isLoadingAuthServices,
    isLoadingFetchLoading,
    setUrl,
    isEdit,
    setRequest,
    authenticationType,
    setAuthenticationType,
    setKey,
    variable,
    sendIn,
    name,
    url,
    request,
    username,
    password,
    token,
    type,
    textbox,
    fieldList,
    destinationType,
    responseHandlerHandler,
    selectedResponseHandler,
    responseStatus,
    selectedTextOrJson,
    selectedContainsOrEquels,
    status,
    apiKey,
    jsonList,
    textValue,
    selectedAuthServiceID,
    maskedCredentials,

    setVariable,
    setSendIn,
    setUsername,
    setPassword,
    setToken,
    setTextbox,
    setFieldList,
    setFields,
    setJsons,
    setResponseHandlerHandler,
    setSelectedResponseHandler,
    setResponseStatus,
    setSelectedTextOrJson,
    setSelectedContainsOrEquels,
    setType,
    setJsonList,
    setTextValue,
    setStatus,
    setName,
    setSelectedAuthServiceId,
    setIsAuthServiceModalOpen,
    setMaskedCredentials,
}) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    const sendDataToParent = useCallback(
        (data) => {
            let result =
                data.length > 0 &&
                data.map((item) => {
                    return {
                        name: item.field,
                        type: item.field,
                        required: item.required ? true : false,
                    };
                });
            setFields(result);
        },
        [setFields],
    );
    const sendDataToParentForJson = useCallback(
        (data) => {
            let result =
                data.length > 0 &&
                data.map((item) => {
                    return { name: item.key, type: item.value };
                });
            setJsons(result);
        },
        [setJsons],
    );

    const isValidJson = () => {
        if (type !== "Raw-Json") return true;
        try {
            JSON.parse(textbox);
            return true;
        } catch (error) {
            return false;
        }
    };

    return (
        <Modal.Body>
            <Styled.ModalBodyInnerContainer>
                <Form>
                    <Row className="p-0">
                        <Col xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <FormControl
                                    style={{ width: "100%" }}
                                    error={error?.name}
                                >
                                    <TextField
                                        label={
                                            language?.trackers_page?.name ??
                                            "Name"
                                        }
                                        variant="outlined"
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                        value={name}
                                        error={error?.name}
                                    />
                                    {error?.name && (
                                        <FormHelperText>
                                            {language?.this_field_is_required ??
                                                "This field is required"}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <Col md={6} xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <FormControl
                                    style={{ width: "100%" }}
                                    error={error?.url}
                                >
                                    <TextField
                                        label={
                                            language?.trackers_page?.url ??
                                            "URL"
                                        }
                                        variant="outlined"
                                        onChange={(e) => setUrl(e.target.value)}
                                        value={url}
                                        error={error?.url}
                                    />
                                    {error?.url && (
                                        <FormHelperText>
                                            {error.url}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <>
                            <Col md={6} xs={12}>
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <FormControl style={{ width: "100%" }}>
                                        <Select
                                            label={
                                                language?.footer?.method ??
                                                "Method"
                                            }
                                            onChange={(event) =>
                                                setRequest(event.target.value)
                                            }
                                            value={request}
                                        >
                                            <MenuItem key="post" value="post">
                                                {language?.creat_web_servis
                                                    ?.post ?? "POST"}
                                            </MenuItem>
                                            <MenuItem key="put" value="put">
                                                {language?.creat_web_servis
                                                    ?.put ?? "PUT"}
                                            </MenuItem>
                                            <MenuItem key="patch" value="patch">
                                                {language?.creat_web_servis
                                                    ?.patch ?? "PATCH"}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Group
                                    className="mb-3"
                                    controlId="exampleForm.ControlInput1"
                                >
                                    <FormControl style={{ width: "100%" }}>
                                        <Select
                                            label={
                                                language?.footer?.form_type ??
                                                "Form Type"
                                            }
                                            onChange={(event) => {
                                                setType(event.target.value);
                                                // Only clear textbox in create mode, preserve in edit mode
                                                if (!isEdit) {
                                                    setTextbox("");
                                                }
                                            }}
                                            value={type}
                                        >
                                            <MenuItem
                                                key="Form-Data"
                                                value="Form-Data"
                                            >
                                                {language?.creat_web_servis
                                                    ?.form_data ?? "Form Data"}
                                            </MenuItem>

                                            <MenuItem
                                                key="Raw-Json"
                                                value="Raw-Json"
                                            >
                                                {language?.creat_web_servis
                                                    ?.raw_json ?? "Raw Json"}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        </>
                        <Col md={isEdit ? 6 : 6} xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <FormControl style={{ width: "100%" }}>
                                    <Select
                                        label={
                                            language?.footer?.status ?? "Status"
                                        }
                                        onChange={(event) =>
                                            setStatus(event.target.value)
                                        }
                                        value={status}
                                    >
                                        <MenuItem key="active" value="active">
                                            {language?.creat_web_servis
                                                ?.active ?? "Active"}
                                        </MenuItem>
                                        <MenuItem key="passive" value="passive">
                                            {language?.creat_web_servis
                                                ?.passive ?? "Passive"}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <Col md={6} xs={12}>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlInput1"
                            >
                                <FormControl style={{ width: "100%" }}>
                                    <Select
                                        label={
                                            language?.footer
                                                ?.authentication_type ??
                                            "Authentication Type"
                                        }
                                        onChange={(event) =>
                                            setAuthenticationType(
                                                event.target.value,
                                            )
                                        }
                                        value={authenticationType}
                                    >
                                        <MenuItem key="api-key" value="api-key">
                                            {language?.creat_web_servis
                                                ?.api_key ?? "Api Key"}
                                        </MenuItem>
                                        <MenuItem key="basic" value="basic">
                                            {language?.creat_web_servis
                                                ?.basic ?? "Basic"}
                                        </MenuItem>
                                        <MenuItem key="bearer" value="bearer">
                                            {language?.creat_web_servis
                                                ?.bearer ?? "Bearer"}
                                        </MenuItem>
                                        <MenuItem key="no-auth" value="no-auth">
                                            {language?.creat_web_servis?.none ??
                                                "None"}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Form.Group>
                        </Col>

                        <>
                            {authenticationType === "api-key" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            error={error?.key}
                                            required
                                        >
                                            <TextField
                                                label={
                                                    language?.trackers_page
                                                        ?.key ?? "Key"
                                                }
                                                variant="outlined"
                                                required
                                                onChange={(e) =>
                                                    setKey(e.target.value)
                                                }
                                                onFocus={() => {
                                                    if (
                                                        maskedCredentials?.key
                                                    ) {
                                                        setKey("");
                                                        setMaskedCredentials(
                                                            (prev) => ({
                                                                ...prev,
                                                                key: false,
                                                            }),
                                                        );
                                                    }
                                                }}
                                                value={apiKey}
                                                error={error?.key}
                                            />
                                            {error?.key && (
                                                <FormHelperText>
                                                    {language?.this_field_is_required ??
                                                        "This field is required"}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                            {authenticationType === "api-key" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            error={error?.variable}
                                            required
                                        >
                                            <TextField
                                                label={
                                                    language?.trackers_page
                                                        ?.variable ?? "Variable"
                                                }
                                                variant="outlined"
                                                required
                                                onChange={(e) =>
                                                    setVariable(
                                                        e.target.value.trim(),
                                                    )
                                                }
                                                onFocus={() => {
                                                    if (
                                                        maskedCredentials?.variable
                                                    ) {
                                                        setVariable("");
                                                        setMaskedCredentials(
                                                            (prev) => ({
                                                                ...prev,
                                                                variable: false,
                                                            }),
                                                        );
                                                    }
                                                }}
                                                value={variable}
                                                error={error?.variable}
                                            />
                                            {error?.variable && (
                                                <FormHelperText>
                                                    {language?.this_field_is_required ??
                                                        "This field is required"}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                            {authenticationType === "api-key" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            required
                                        >
                                            <Select
                                                label={
                                                    language?.footer?.where ??
                                                    "Where"
                                                }
                                                onChange={(event) =>
                                                    setSendIn(
                                                        event.target.value,
                                                    )
                                                }
                                                value={sendIn}
                                                error={error?.sendIn}
                                            >
                                                <MenuItem
                                                    key="header"
                                                    value="header"
                                                >
                                                    {language?.creat_web_servis
                                                        ?.header ?? "Header"}
                                                </MenuItem>
                                                <MenuItem
                                                    key="query-params"
                                                    value="query-params"
                                                >
                                                    {language?.creat_web_servis
                                                        ?.query_parameters ??
                                                        "Query Parameters"}
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                            {authenticationType === "basic" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            error={error?.username}
                                        >
                                            <TextField
                                                label={
                                                    language?.trackers_page
                                                        ?.user_name ??
                                                    "User name"
                                                }
                                                variant="outlined"
                                                required
                                                onChange={(e) =>
                                                    setUsername(
                                                        e.target.value.trim(),
                                                    )
                                                }
                                                onFocus={() => {
                                                    if (
                                                        maskedCredentials?.username
                                                    ) {
                                                        setUsername("");
                                                        setMaskedCredentials(
                                                            (prev) => ({
                                                                ...prev,
                                                                username: false,
                                                            }),
                                                        );
                                                    }
                                                }}
                                                value={username}
                                                error={error?.username}
                                            />
                                            {error?.username && (
                                                <FormHelperText>
                                                    {language?.this_field_is_required ??
                                                        "This field is required"}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                            {authenticationType === "basic" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            error={error?.password}
                                        >
                                            <TextField
                                                label={
                                                    language?.trackers_page
                                                        ?.password ?? "Password"
                                                }
                                                variant="outlined"
                                                required
                                                onChange={(e) =>
                                                    setPassword(
                                                        e.target.value.trim(),
                                                    )
                                                }
                                                onFocus={() => {
                                                    if (
                                                        maskedCredentials?.password
                                                    ) {
                                                        setPassword("");
                                                        setMaskedCredentials(
                                                            (prev) => ({
                                                                ...prev,
                                                                password: false,
                                                            }),
                                                        );
                                                    }
                                                }}
                                                value={password}
                                                error={error?.password}
                                            />
                                            {error?.password && (
                                                <FormHelperText>
                                                    {language?.this_field_is_required ??
                                                        "This field is required"}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                            {authenticationType === "bearer" && (
                                <Col md={6} xs={12}>
                                    <Form.Group
                                        className="mb-3"
                                        controlId="exampleForm.ControlInput1"
                                    >
                                        <FormControl
                                            style={{
                                                width: "100%",
                                            }}
                                            error={error?.token}
                                            required
                                        >
                                            <TextField
                                                label={
                                                    language?.trackers_page
                                                        ?.token ?? "Token"
                                                }
                                                variant="outlined"
                                                required
                                                onChange={(e) =>
                                                    setToken(
                                                        e.target.value.trim(),
                                                    )
                                                }
                                                onFocus={() => {
                                                    if (
                                                        maskedCredentials?.token
                                                    ) {
                                                        setToken("");
                                                        setMaskedCredentials(
                                                            (prev) => ({
                                                                ...prev,
                                                                token: false,
                                                            }),
                                                        );
                                                    }
                                                }}
                                                value={token}
                                                error={error?.token}
                                            />
                                            {error?.token && (
                                                <FormHelperText>
                                                    {language?.this_field_is_required ??
                                                        "This field is required"}
                                                </FormHelperText>
                                            )}
                                        </FormControl>
                                    </Form.Group>
                                </Col>
                            )}
                        </>
                        {
                            <Col md={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <FormControl style={{ width: "100%" }}>
                                        <Tooltip
                                            title={
                                                authServices?.length
                                                    ? null
                                                    : "There is no Auth Service."
                                            }
                                        >
                                            <Autocomplete
                                                options={authServices || []}
                                                getOptionLabel={(option) =>
                                                    option.label
                                                }
                                                onChange={(event, newValue) =>
                                                    setSelectedAuthServiceId(
                                                        newValue?.value || "",
                                                    )
                                                }
                                                value={
                                                    authServices?.find(
                                                        (option) =>
                                                            option.value ===
                                                            selectedAuthServiceID,
                                                    ) || null
                                                }
                                                disabled={
                                                    isLoadingAuthServices ||
                                                    !authServices?.length
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Auth Service (optional)"
                                                        variant="outlined"
                                                    />
                                                )}
                                            />
                                        </Tooltip>
                                    </FormControl>
                                </Form.Group>
                            </Col>
                        }
                        <Col md={12} xs={12} className="mb-3">
                            <Stack
                                direction="row"
                                sx={{
                                    justifyContent: {
                                        xs: "center",
                                        md: "flex-end",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            md: "50%",
                                        },
                                        paddingLeft: {
                                            xs: "0",
                                            md: "1rem",
                                        },
                                    }}
                                >
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        fullWidth
                                        onClick={() =>
                                            setIsAuthServiceModalOpen(true)
                                        }
                                        sx={{
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Create Auth Service
                                    </Button>
                                </Box>
                            </Stack>
                        </Col>
                        {type === "Raw-Json" && (
                            <Json
                                error={error}
                                isValidJson={isValidJson}
                                setTextbox={setTextbox}
                                textbox={textbox}
                            />
                        )}
                        {type !== "Raw-Json" && !isLoadingFetchLoading && (
                            <Col xs={12}>
                                <Form.Group>
                                    <AddNewFields
                                        sendDataToParent={sendDataToParent}
                                        error={error?.fields ?? ""}
                                        fieldList={fieldList}
                                        setFieldList={setFieldList}
                                    />
                                </Form.Group>
                            </Col>
                        )}

                        <Col xs={12}>
                            <Form.Group className="justify-content-start row">
                                <Col xs={12}>
                                    {destinationType &&
                                        destinationType === "http" && (
                                            <>
                                                <div className="row d-flex justify-content-start my-4">
                                                    <h2
                                                        aria-controls="example-collapse-customField"
                                                        aria-expanded={
                                                            responseHandlerHandler
                                                        }
                                                        className="col pointerBase"
                                                        title="Click here to add custom field"
                                                        onClick={() =>
                                                            setResponseHandlerHandler(
                                                                !responseHandlerHandler,
                                                            )
                                                        }
                                                    >
                                                        {language?.lead
                                                            ?.response_handler ??
                                                            "Response Handler"}{" "}
                                                        <FontAwesomeIcon
                                                            icon={
                                                                responseHandlerHandler
                                                                    ? faAngleUp
                                                                    : faAngleDown
                                                            }
                                                            className="pointerBase"
                                                            aria-hidden="true"
                                                        />
                                                    </h2>
                                                </div>
                                                <Collapse
                                                    in={responseHandlerHandler}
                                                >
                                                    <div id="example-collapse-customField">
                                                        <div
                                                            className="row d-flex align-items-end"
                                                            style={{
                                                                marginTop:
                                                                    "-15px",
                                                            }}
                                                        >
                                                            <div className="col-6">
                                                                <Form.Control
                                                                    as="select"
                                                                    onChange={(
                                                                        e,
                                                                    ) =>
                                                                        setSelectedResponseHandler(
                                                                            e
                                                                                .target
                                                                                .value,
                                                                        )
                                                                    }
                                                                    value={
                                                                        selectedResponseHandler ??
                                                                        ""
                                                                    }
                                                                >
                                                                    <option
                                                                        key="header"
                                                                        value="header"
                                                                    >
                                                                        {language
                                                                            ?.creat_web_servis
                                                                            ?.header ??
                                                                            "Header"}
                                                                    </option>
                                                                    <option
                                                                        key="body"
                                                                        value="body"
                                                                    >
                                                                        {language
                                                                            ?.lead
                                                                            ?.body ??
                                                                            "Body"}
                                                                    </option>
                                                                </Form.Control>
                                                            </div>
                                                            {selectedResponseHandler &&
                                                                selectedResponseHandler ===
                                                                    "header" && (
                                                                    <div className="col-6">
                                                                        <Form.Label>
                                                                            {language
                                                                                ?.lead
                                                                                ?.response_status ??
                                                                                "Response Status"}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            onChange={(
                                                                                e,
                                                                            ) =>
                                                                                setResponseStatus(
                                                                                    e
                                                                                        .target
                                                                                        .value,
                                                                                )
                                                                            }
                                                                            value={
                                                                                responseStatus ??
                                                                                ""
                                                                            }
                                                                            placeholder="Value1, Value2"
                                                                        ></Form.Control>
                                                                    </div>
                                                                )}
                                                        </div>
                                                        {selectedResponseHandler &&
                                                            selectedResponseHandler ===
                                                                "body" && (
                                                                <div className="row d-flex align-items-end">
                                                                    <div className="col-6 py-1">
                                                                        <Form.Control
                                                                            as="select"
                                                                            onChange={(
                                                                                e,
                                                                            ) =>
                                                                                setSelectedTextOrJson(
                                                                                    e
                                                                                        .target
                                                                                        .value,
                                                                                )
                                                                            }
                                                                            value={
                                                                                selectedTextOrJson ??
                                                                                ""
                                                                            }
                                                                        >
                                                                            <option
                                                                                key="text"
                                                                                value="text"
                                                                            >
                                                                                {language
                                                                                    ?.lead
                                                                                    ?.text ??
                                                                                    "Text"}
                                                                            </option>
                                                                            <option
                                                                                key="json"
                                                                                value="json"
                                                                            >
                                                                                Json
                                                                            </option>
                                                                        </Form.Control>
                                                                    </div>
                                                                    {selectedTextOrJson ===
                                                                        "" && (
                                                                        <div className="col-12"></div>
                                                                    )}
                                                                    {selectedTextOrJson &&
                                                                        selectedTextOrJson ===
                                                                            "text" && (
                                                                            <div className="col-12">
                                                                                <div className="row d-flex align-items-end">
                                                                                    <div className="col-6 py-1">
                                                                                        <Form.Control
                                                                                            as="select"
                                                                                            onChange={(
                                                                                                e,
                                                                                            ) =>
                                                                                                setSelectedContainsOrEquels(
                                                                                                    e
                                                                                                        .target
                                                                                                        .value,
                                                                                                )
                                                                                            }
                                                                                            value={
                                                                                                selectedContainsOrEquels ??
                                                                                                ""
                                                                                            }
                                                                                        >
                                                                                            <option
                                                                                                key="contains"
                                                                                                value="contains"
                                                                                            >
                                                                                                {language
                                                                                                    ?.lead
                                                                                                    ?.contains ??
                                                                                                    "Contains"}
                                                                                            </option>
                                                                                            <option
                                                                                                key="equals"
                                                                                                value="equals"
                                                                                            >
                                                                                                {language
                                                                                                    ?.lead
                                                                                                    ?.equals ??
                                                                                                    "Equals"}
                                                                                            </option>
                                                                                        </Form.Control>
                                                                                    </div>
                                                                                    <div className="col-6 py-1">
                                                                                        <Form.Label>
                                                                                            {language
                                                                                                ?.lead
                                                                                                ?.text_value ??
                                                                                                "Text Value"}
                                                                                        </Form.Label>
                                                                                        <Form.Control
                                                                                            onChange={(
                                                                                                e,
                                                                                            ) =>
                                                                                                setTextValue(
                                                                                                    e
                                                                                                        .target
                                                                                                        .value,
                                                                                                )
                                                                                            }
                                                                                            value={
                                                                                                textValue ??
                                                                                                ""
                                                                                            }
                                                                                            placeholder="Value1, Value2"
                                                                                        ></Form.Control>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                    {selectedTextOrJson &&
                                                                        selectedTextOrJson ===
                                                                            "json" && (
                                                                            <div className="col-12">
                                                                                <div className="row d-flex ">
                                                                                    <AddNewWebServiceJson
                                                                                        sendDataToParentForJson={
                                                                                            sendDataToParentForJson
                                                                                        }
                                                                                        error={
                                                                                            error?.jsons ??
                                                                                            ""
                                                                                        }
                                                                                        jsonList={
                                                                                            jsonList
                                                                                        }
                                                                                        setJsonList={
                                                                                            setJsonList
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                </div>
                                                            )}
                                                    </div>
                                                </Collapse>
                                            </>
                                        )}
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Styled.ModalBodyInnerContainer>
        </Modal.Body>
    );
};

export default Content;
